import { translations } from './translations';

function translateText(sModuleName, label, languageCode, replacements) {
  let translatedText = translations[sModuleName][label][languageCode];

  if (replacements) {
    Object.keys(replacements).forEach(sPlaceholder => {
      translatedText = translatedText.replace(`{${sPlaceholder}}`, replacements[sPlaceholder]);
    });
  }

  return translatedText;
}

export { translateText };